/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { runDeploymentQueue } from "../../funcs/runDeploymentQueue.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.DeploymentRunRequest$inboundSchema,
};

export const tool$runDeploymentQueue: ToolDefinition<typeof args> = {
  name: "run-deployment-queue",
  description: `Queue Run

Create a new deployment run with the given parameters.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await runDeploymentQueue(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
